export default __webpack_public_path__ + "static/media/no-image.a347c955.png";